import React from "react";
import "./App.css";
import "./css/font-awesome.min.css";
import Navbar from "./js/components/navbar";
import "./css/main.css";
import Footer from "./js/components/footer";
class App extends React.Component {
  render() {
    return (
      <div className="App">
        <h1>This website has moved to a different domain</h1>
        <a href='https://gauravmadarkal.com'>Please click here to be redirected to the correct one</a>
      </div>
    );
  }
}

export default App;
